import { Link } from "react-router-dom";
import heroBanner from "../../assets/images/pages/8-hour-idi.png";
import ShellCard from "../../components/ShellCard";

const EightHourCourse = () => {
  return (
    <>
      <section className="hero-slider-section">
        <div
          className="hero-banner"
          style={{
            backgroundImage: `url(${heroBanner})`,
          }}
        >
          <div className="banner-text-container">
            <div className="banner-heading">
              <h1 className="banner-title">8 Hour Course</h1>
              <p className="banner-subheading">State of Florida Certified</p>
            </div>
          </div>
        </div>
      </section>
      <div className="container my-5">
        <div className="row justify-content-center">
          <div className="col-12">
            <ShellCard>
              <h3 className="mb-4" style={{ color: "var(--metro-yellow)" }}>
                Course Description
              </h3>
              <div className="course-body">
                <div className="mb-4">
                  <p className="text-white mt-0 lead-paragraph fs-5">
                    The 8 Hour Intermediate Driver Improvement Course may be
                    taken{" "}
                    <a
                      href="/online-traffic-school"
                      className="text-warning fw-bold text-decoration-none"
                    >
                      Online
                    </a>{" "}
                    anywhere in Florida or in one of our classroom locations in
                    South Florida.
                  </p>
                </div>

                <div className="mb-4">
                  <p className="text-white mb-0">
                    This course is similar in context to the 4 Hour, but is a
                    bit more detailed in addressing driver safety.
                  </p>
                </div>

                <div className="mb-4">
                  <p className="text-white mb-0">
                    This course may be taken in place of the 4 Hour course in
                    SOME COUNTIES if you have already taken a 4 Hour course
                    within the past twelve months, in order to avoid points for
                    the second traffic violation. Please see the list of County
                    Clerks of Court, and contact the clerk of court in the
                    county in which the ticket was received to verify if they
                    accept the 8 Hour Program. See Eligibility tab.
                  </p>
                </div>

                <div className="mb-4">
                  <p className="text-white mb-0">
                    This Course may also, and often is, taken due to a judge
                    ordering the completion of an 8 Hour program for a
                    particular citation or for aggressive driving. If you are
                    completing the 8 Hour course as a result of a judge order,
                    it is important to know if you were ordered to complete the
                    Aggressive version. If that is the case, be sure to select
                    that option if you are enrolling yourself for the Online
                    course or let us know at the time of enrollment if
                    completing in the classroom.
                  </p>
                </div>

                <div className="mb-5">
                  <p className="text-white mb-0">
                    In either case, Election or Judgment, it may be completed by{" "}
                    <a
                      href="/online-traffic-school"
                      className="text-warning fw-bold text-decoration-none"
                    >
                      Internet
                    </a>{" "}
                    or in the{" "}
                    <a
                      href="/classroom-traffic-school"
                      className="text-warning fw-bold text-decoration-none"
                    >
                      Classroom
                    </a>
                    .
                  </p>
                </div>

                <div className="my-3 container contact-call">
                  <p className="mt-3 fw-bold mb-0">
                    Call{" "}
                    <a href="tel:1-888-41-METRO" className="contact-phone">
                      1-888-41-METRO
                    </a>{" "}
                    for more information.
                  </p>
                </div>
              </div>
            </ShellCard>
          </div>
        </div>
      </div>
    </>
  );
};

export default EightHourCourse;
